import { memo } from 'react';
import LazyLoad from 'react-lazyload';
import ossImgCompress, { canUseWebp } from '@/utils/ossImgCompress';
import styles from './index.module.less';

/**
 * 存在两种懒加载方案、可以自动设置高度的video组件
 * @param {Object} style video元素的style
 * @param {Object} outerStyle video元素父级组件的style
 * @param  src 采用LazyLoad 懒加载组件加载
 * @param  poster 采用LazyLoad 懒加载组件加载
 * @param  data_src 不采用懒加载组件（否则获取不到video元素），配合VideoLazyLoad使用
 * @param  data_poster 不采用懒加载组件，配合VideoLazyLoad使用
 * @param  offset
 * @param {Array} ratio 视频宽高比例，设置后需要设定父级className的宽度
 * @param  className
 * @param  autoPlay
 * @param  onClick
 * @param {object} videoProps
 * @param {boolean} loop
 * @returns
 */
const Index = (props) => {
  let {
    src,
    poster,
    data_src,
    data_poster,
    dataSlideSrc,
    dataSlidePoster,
    offset = 400,
    ratio,
    className,
    autoPlay = true,
    onClick,
    videoProps,
    outerStyle = {},
    videoRef,
    style = { width: '100%' },
    key,
    loop = true,
    webp,
  } = props;

  poster = webp || canUseWebp(poster) ? ossImgCompress(poster, { webp: true }) : poster;
  data_poster = webp || canUseWebp(data_poster) ? ossImgCompress(data_poster, { webp: true }) : data_poster;

  return data_src || dataSlideSrc ? (
    <div key={key} className={[styles.lazyVideo1, className].join(' ')} style={outerStyle}>
      <span
        className={styles.ratioSpan}
        style={{ paddingBottom: Array.isArray(ratio) && `${(ratio[1] / ratio[0]) * 100}%` }}
      />
      <video
        data-src={data_src}
        data-poster={data_poster || poster}
        data-slide-poster={dataSlidePoster}
        data-slide-src={dataSlideSrc}
        poster={poster}
        src={src}
        style={style}
        disablePictureInPicture
        autoPlay={autoPlay}
        loop={loop}
        ref={videoRef}
        muted
        playsInline
        controls={false}
        onClick={onClick}
        {...videoProps}
      />
    </div>
  ) : (
    <LazyLoad
      key={key}
      offset={offset}
      className={[styles.lazyVideo, className].join(' ')}
      style={{ ...outerStyle, paddingBottom: Array.isArray(ratio) ? `${(ratio[1] / ratio[0]) * 100}%` : 'auto' }}
    >
      <video
        src={src}
        style={style}
        poster={poster}
        disablePictureInPicture
        autoPlay={autoPlay}
        loop={loop}
        ref={videoRef}
        muted
        playsInline
        controls={false}
        onClick={onClick}
        {...videoProps}
      />
    </LazyLoad>
  );
};
const LazyLoadVideo = memo(Index);

export default LazyLoadVideo;
